// extracted by mini-css-extract-plugin
export default {"title":"Title_title__E4IyZ","bolder":"Title_bolder__QwIYC","small":"Title_small__uK0SM"};